// Préférences utilisateur (persistées par compte via /api/me/settings).
// Un cache module permet aux fonctions de formatage d'être utilisées partout
// (y compris dans des formatteurs hors composant React).

export const DEFAULT_SETTINGS = {
  // --- Système ---
  display_name: "",
  timezone: "Pacific/Noumea",
  language: "fr",
  distance_unit: "km", // km | mi
  volume_unit: "L", // L | gal
  speed_unit: "kmh", // kmh | mph
  fuel_econ_unit: "l_100km", // l_100km | mpg
  date_format: "dd MMM yyyy", // dd MMM yyyy | dd/MM/yyyy | yyyy-MM-dd | MM/dd/yyyy
  temp_unit: "C", // C | F
  messages_per_page: 10,
  purge_days: 365,
  home_page: "/dashboard",
  sound_alert: false,
  message_notification: false,
  driver_name_format: "name", // name | badge | none

  // --- Préférences carte ---
  map_type: "satellite", // dark | light | osm | satellite
  dynamic_label_zoom: true,
  driver_label_on_unit: false,
  cluster_vehicles: false,
  show_vehicles: true,
  show_pois: true,
  show_forbidden_zones: true,
  show_geofences: true,
  poi_zoom: 15,
  vehicle_labels: true,

  // --- Tracking (infos affichées sur la carte / popups) ---
  track_show_diagnostics: true,
  track_show_io: true,
  track_show_driver: true,
  track_show_location: true,
  track_show_last_gps: true,
  track_show_odometer: true,
  track_show_coords: false,
  track_highlight_last_trip: true,
};

let _s = { ...DEFAULT_SETTINGS };

export function setUserSettings(s) {
  _s = { ...DEFAULT_SETTINGS, ...(s || {}) };
}
export function getUserSettings() {
  return _s;
}

const tz = () => _s.timezone || "Pacific/Noumea";
const locale = () => (_s.language === "en" ? "en-US" : "fr-FR");

const DATE_OPTS = {
  "dd MMM yyyy": { day: "2-digit", month: "short", year: "numeric" },
  "dd/MM/yyyy": { day: "2-digit", month: "2-digit", year: "numeric" },
  "yyyy-MM-dd": { year: "numeric", month: "2-digit", day: "2-digit" },
  "MM/dd/yyyy": { month: "2-digit", day: "2-digit", year: "numeric" },
};

export function fmtDate(iso) {
  if (!iso) return "—";
  const opts = DATE_OPTS[_s.date_format] || DATE_OPTS["dd MMM yyyy"];
  return new Date(iso).toLocaleDateString(locale(), { timeZone: tz(), ...opts });
}

export function fmtTime(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleTimeString(locale(), { timeZone: tz(), hour: "2-digit", minute: "2-digit" });
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  const opts = DATE_OPTS[_s.date_format] || DATE_OPTS["dd MMM yyyy"];
  return new Date(iso).toLocaleString(locale(), { timeZone: tz(), ...opts, hour: "2-digit", minute: "2-digit" });
}

// Version courte jour/mois + heure (usage carte / popups).
export function fmtShort(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleString(locale(), { timeZone: tz(), day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
}

// --- Unités ---
export function speedStr(kmh, marine = false) {
  const v = kmh || 0;
  if (marine) return `${Math.round(v * 0.539957)} nds`;
  if (_s.speed_unit === "mph") return `${Math.round(v * 0.621371)} mph`;
  return `${Math.round(v)} km/h`;
}

export function distStr(km) {
  const v = km || 0;
  if (_s.distance_unit === "mi") return `${(v * 0.621371).toFixed(1)} mi`;
  return `${Math.round(v * 10) / 10} km`;
}

export function tempStr(c) {
  if (c == null) return "—";
  if (_s.temp_unit === "F") return `${Math.round((c * 9) / 5 + 32)} °F`;
  return `${Math.round(c)} °C`;
}

// Libellé du conducteur selon le format choisi. Normalise les espaces et ne renvoie RIEN
// quand aucun vrai nom n'est présent (jamais « non identifié », jamais un n° de badge en mode nom).
export function driverLabel(v) {
  if (!v || _s.driver_name_format === "none") return "";
  const norm = (x) => (x == null ? "" : String(x)).trim();
  const name = norm(v.current_driver_name) || norm(v.driver);
  if (_s.driver_name_format === "badge") return norm(v.current_driver_tag) || norm(v.driver_tag) || name;
  return name;
}
